import { SimpleUser } from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

interface ServicedUserState {
    employerId: number;
    employerName: string;
    firstName: string;
    lastName: string;
}

interface CustomerServiceUserState {
    loadedUsers: { [cognitoUsername: string]: ServicedUserState; };
    loadingUsers: { [cognitoUsername: string]: boolean; };
}

const emptyState: CustomerServiceUserState = {
    loadedUsers: {},
    loadingUsers: {}
};

export const useCustomerServiceUserStore = defineStore("customerServiceUser", {
    state: (): CustomerServiceUserState => (_.cloneDeep(emptyState)),
    getters: {
        userInfo: state => (username: string): { firstName: string, lastName: string, employerName: string } =>
            (username in state.loadedUsers) ? state.loadedUsers[username] : null
    },
    actions: {
        beginLoadingUser (username: string) {
            this.loadingUsers = { ...this.loadingUsers, [username]: true };
        },
        loadedUser ({ username, simpleUser }: { username: string, simpleUser: SimpleUser }) {
            const loadingUsersCopy = { ...this.loadingUsers };
            delete loadingUsersCopy[username];
            this.loadingUsers = loadingUsersCopy;

            const detail = {
                employerId: simpleUser.employerId ? simpleUser.employerId : 0,
                employerName: simpleUser.employerName ? simpleUser.employerName : "",
                firstName: simpleUser.firstName,
                lastName: simpleUser.lastName
            };

            this.loadedUsers = { ...this.loadedUsers, [username]: detail };
        },
        loadUser (args: { username: string, partnerId: number }): Promise<void> {
            if (this.loadingUsers[args.username] || this.loadedUsers[args.username]) {
                return Promise.resolve();
            }

            this.beginLoadingUser(args.username);

            return UserService.getSimpleUser(args.partnerId, args.username)
                .then(
                    axiosResponse => this.loadedUser({ username: args.username, simpleUser: axiosResponse.data }))
                .catch(error => storeHelper.handleError({ error, rethrow: false }));
        }
    }
});